$(document).ready(() => {
  // prevent usf scroll
  // localStorage.setItem('usf-scroll', '0.1');
  // localStorage.setItem('usf-scroll', '0');

  $(".main-loader").fadeOut();

  function mobileMenuDrawer() {
    $(".Drawer-back").on("click", function () {
      $(".Collapsible__Inner").removeClass("visible");
      setTimeout(function () {
        $(".Collapsible__Button").attr("aria-expanded", false);
      }, 500);
      $(this).hide();
      $(".Drawer__Close").show();
    });
  }

  function testimonials() {
    const $testimonialsSlider = $(".TestimonialList");
    if ($testimonialsSlider.length) {
      $testimonialsSlider.slick({
        dots: true,
        slidesToShow: 2,
        slidesToScroll: 2,
        responsive: [
          {
            breakpoint: 768,
            settings: {
              slidesToShow: 1,
              slidesToScroll: 1,
              infinite: true,
              dots: true,
            },
          },
        ],
      });
    }
  }

  function heroSlider() {
    const $hero = $(".hero-slider");
    if ($hero.length) {
      setTimeout(function () {
        $hero.slick({
          dots: true,
          arrows: true,
          slidesToShow: 1,
          slidesToScroll: 1,
          infinite: true,
          fade: true,
          prevArrow:
            '<button type="button" class="slick-prev pull-left"><svg width="14" height="23" viewBox="0 0 14 23" fill="none"><path d="M14 20.1251L5.91335 11.4084L14 2.69167L11.5029 -1.09152e-07L0.919143 11.4084L11.5029 22.8168L14 20.1251Z" fill="#939C9E"/></svg></button>',
          nextArrow:
            '<button type="button" class="slick-next pull-right"><svg width="14" height="23" viewBox="0 0 14 23" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M-8.79696e-07 2.69167L8.08665 11.4084L-1.17656e-07 20.1251L2.4971 22.8168L13.0809 11.4084L2.4971 -1.09152e-07L-8.79696e-07 2.69167Z" fill="#939C9E"/></svg></button>',
        });
      }, 100);
    }
  }

  function logoSlider() {
    const $container = $(".logo-bar-slider");
    if ($container.length) {
      $container.slick({
        dots: false,
        arrows: true,
        slidesToShow: 6,
        slidesToScroll: 1,
        infinite: true,
        autoplay: true,
        autoplaySpeed: 5000,
        prevArrow:
          '<button type="button" class="slick-prev pull-left"><svg width="14" height="23" viewBox="0 0 14 23" fill="none"><path d="M14 20.1251L5.91335 11.4084L14 2.69167L11.5029 -1.09152e-07L0.919143 11.4084L11.5029 22.8168L14 20.1251Z" fill="#939C9E"/></svg></button>',
        nextArrow:
          '<button type="button" class="slick-next pull-right"><svg width="14" height="23" viewBox="0 0 14 23" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M-8.79696e-07 2.69167L8.08665 11.4084L-1.17656e-07 20.1251L2.4971 22.8168L13.0809 11.4084L2.4971 -1.09152e-07L-8.79696e-07 2.69167Z" fill="#939C9E"/></svg></button>',
        responsive: [
          {
            breakpoint: 1280,
            settings: {
              slidesToShow: 4,
              slidesToScroll: 1,
            },
          },
          {
            breakpoint: 641,
            settings: "unslick",
          },
        ],
      });
    }
  }

  mobileMenuDrawer();
  heroSlider();
  testimonials();
  logoSlider();
});

document.addEventListener("DOMContentLoaded", function () {
  function product() {
    if ($(".template-product").length) {
      if (localStorage.getItem("tax") === "active") {
        $(".product__toggle-check").addClass("active");
      }
      window.changeTax();

      $(".product__gallery-big").slick({
        asNavFor: ".product__gallery-small",
        touchMove: false,
        infinite: false,
        touchThreshold: 10000,
        dots: false,
        responsive: [
          {
            breakpoint: 1008,
            settings: {
              dots: true,
            },
          },
        ],
      });

      const navItemCount = $(".product__gallery-small").children().length;
      $(".product__gallery-small").slick({
        slidesToShow: 5,
        slidesToScroll: 1,
        dots: false,
        focusOnSelect: true,
        touchThreshold: 2000,
        infinite: false,
        asNavFor: ".product__gallery-big",
        arrows: true,
        prevArrow:
          '<button type="button" class="slick-prev pull-left"><svg width="7" height="11" viewBox="0 0 14 23" fill="none"><path d="M14 20.1251L5.91335 11.4084L14 2.69167L11.5029 -1.09152e-07L0.919143 11.4084L11.5029 22.8168L14 20.1251Z" fill="#939C9E"/></svg></button>',
        nextArrow:
          '<button type="button" class="slick-next pull-right"><svg width="7" height="11" viewBox="0 0 14 23" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M-8.79696e-07 2.69167L8.08665 11.4084L-1.17656e-07 20.1251L2.4971 22.8168L13.0809 11.4084L2.4971 -1.09152e-07L-8.79696e-07 2.69167Z" fill="#939C9E"/></svg></button>',
        responsive: [
          {
            breakpoint: 1008,
            settings: {
              slidesToShow: 5,
              slidesToScroll: 1,
              arrows: false,
            },
          },
        ],
      });
      if (navItemCount <= 5) $(".product__gallery-small").addClass("no-scroll");

      $('[data-action="decrease-quantity"]').click(function (e) {
        e.preventDefault();
        if (+$(this).siblings("input").val() < 2) {
          $(this).siblings("input").val(0);
        } else {
          $(this)
            .siblings("input")
            .val(+$(this).siblings("input").val() - 1);
        }
      });

      $(".m-tabs__title").click(function () {
        $(this).siblings(".m-tabs__content").slideToggle();
      });

      $(".m-tabs__tab").click(function () {
        let index = $(this).attr("data-index");
        $(".m-tabs__tab, .m-tabs__image, .m-tabs__product-inner").removeClass(
          "active"
        );
        $(
          `.m-tabs__tab[data-index=${index}], .m-tabs__image[data-index=${index}], .m-tabs__product-inner[data-index=${index}]`
        ).addClass("active");
      });

      if (
        $(window).innerWidth() < 768 &&
        $(".related__list .related__item").length > 1
      ) {
        $(".related__list").slick({
          variableWidth: true,
          slidesToShow: 1,
          slidesToScroll: 1,
          infinite: true,
          dots: true,
          autoplay: true,
          autoplaySpeed: 3000,
          swipeToSlide: true,
          touchThreshold: 2000,
          fade: false,
          swipe: true,
          arrows: false,
          prevArrow:
            '<button type="button" class="slick-prev pull-left"><svg width="14" height="23" viewBox="0 0 14 23" fill="none"><path d="M14 20.1251L5.91335 11.4084L14 2.69167L11.5029 -1.09152e-07L0.919143 11.4084L11.5029 22.8168L14 20.1251Z" fill="#939C9E"/></svg></button>',
          nextArrow:
            '<button type="button" class="slick-next pull-right"><svg width="14" height="23" viewBox="0 0 14 23" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M-8.79696e-07 2.69167L8.08665 11.4084L-1.17656e-07 20.1251L2.4971 22.8168L13.0809 11.4084L2.4971 -1.09152e-07L-8.79696e-07 2.69167Z" fill="#939C9E"/></svg></button>',
        });
      }

      if (
        $(window).innerWidth() >= 768 &&
        $(".related__list .related__item").length > 4
      ) {
        $(".related__list").slick({
          variableWidth: false,
          slidesToShow: 4,
          swipeToSlide: true,
          dots: true,
          infinite: true,
          autoplay: true,
          autoplaySpeed: 3000,
          // arrows: false,
          prevArrow:
            '<button type="button" class="slick-prev pull-left"><svg width="24" height="25" viewBox="0 0 24 25" fill="none" xmlns="http://www.w3.org/2000/svg">\n' +
            '<path d="M10.8284 12.864L15.7782 17.8137L14.364 19.2279L8 12.864L14.364 6.5L15.7782 7.91421L10.8284 12.864Z" fill="#530058"/>\n' +
            "</svg>\n</button>",
          nextArrow:
            '<button type="button" class="slick-next pull-right"><svg width="24" height="25" viewBox="0 0 24 25" fill="none" xmlns="http://www.w3.org/2000/svg">\n' +
            '<path d="M13.1714 12.864L8.22168 7.91421L9.63589 6.5L15.9999 12.864L9.63589 19.2279L8.22168 17.8137L13.1714 12.864Z" fill="#530058"/>\n' +
            "</svg>\n</button>",
          responsive: [
            {
              breakpoint: 1919,
              settings: {
                variableWidth: true,
              },
            },
          ],
        });
      }

      $(".related__select").change(function () {
        let option = $(this).find("option:selected");
        let img = $(option).attr("data-img");
        let price = $(option).attr("data-price");
        let taxPrice = $(option).attr("data-tax-price");
        let comparePrice = $(option).attr("data-compare");
        let taxComparePrice = $(option).attr("data-tax-compare");
        if ($(".product__toggle-check").hasClass("active")) {
          $(this)
            .closest(".related__item-info")
            .find(".related__item-price")
            .html(taxPrice);
          $(this)
            .closest(".related__item-info")
            .find(".related__item-price-compare")
            .html(taxComparePrice);
        } else {
          $(this)
            .closest(".related__item-info")
            .find(".related__item-price")
            .html(price);
          $(this)
            .closest(".related__item-info")
            .find(".related__item-price-compare")
            .html(comparePrice);
        }
        $(this).closest(".related__item").find("img").attr("src", img);
      });

      $(".product-select").change(function () {
        let option = $(this).find("option:selected");
        let img = $(option).attr("data-img");
        let price = $(option).attr("data-price");
        let tax = $(option).attr("data-tax-price");
        $(".product__price").attr("data-tax", tax);
        $(".product__price").attr("data-price", price);
        changeTax();
        $(".product__gallery-small").find(`img[data-img="${img}"]`).click();
        console.log(img);
      });
    }
    if ($(".template-index").length) {
      window.changeTax();
    }
  }

  $(".product__toggle-check").click(function (e) {
    e.preventDefault();
    $(".product__toggle-check").toggleClass("active");
    $(".product__toggle-check").hasClass("active")
      ? localStorage.setItem("tax", "active")
      : localStorage.setItem("tax", "none");

    window.changeTax();
  });

  window.changeTax = function () {
    if ($(".product__toggle-check").hasClass("active")) {
      $(".related__select option:selected").each(function () {
        let taxPrice = $(this).attr("data-tax-price");
        let taxComparePrice = $(this).attr("data-tax-compare");
        $(this)
          .parents(".related__item-info")
          .find(".related__item-price")
          .html(taxPrice);
        $(this)
          .parents(".related__item-info")
          .find(".related__item-price-compare")
          .html(taxComparePrice);
      });

      $("[data-tax], .js-price").each(function () {
        $(this).html($(this).attr("data-tax"));
      });
    } else {
      $(".related__select option:selected").each(function () {
        let price = $(this).attr("data-price");
        let comparePrice = $(this).attr("data-compare");
        $(this)
          .parents(".related__item-info")
          .find(".related__item-price")
          .html(price);
        $(this)
          .parents(".related__item-info")
          .find(".related__item-price-compare")
          .html(comparePrice);
      });

      $("[data-tax], .js-price").each(function () {
        $(this).html($(this).attr("data-price"));
      });
    }
    window.changeSplittedPrice();
  };

  product();
  // window.changeTax();
});

window.changeSplittedPrice = function () {
  if ($("#splittedPrice").length) {
    console.log($(".product__prices .product__price").attr("data-tax"));
    let price = parseFloat(
      $(".product__prices .product__price")
        .attr("data-tax")
        .replace(".", "")
        .replace(",", ".")
    );
    let splittedPrice = Math.round((price / 44) * 100) / 100;
    $("#splittedPrice").html(splittedPrice);
  }
};

document.addEventListener("DOMContentLoaded", function () {
  //Scroll Headbar
  if (window.innerWidth >= 1008) {
    $(window).on("scroll", function (event) {
      var scroll = $(window).scrollTop();
      if (scroll > 50) {
        $(".page-uus-kontor .Header").removeClass("Header--transparent");
        $(".page-contacts .Header").removeClass("Header--transparent");
        $(".Header").removeClass("Header--gray");
      } else {
        $(".page-uus-kontor .Header").addClass("Header--transparent");
        $(".page-contacts .Header").addClass("Header--transparent");
        $(".Header").addClass("Header--gray");
      }
    });

    $(".page-uus-kontor .Header").on("mouseover", function () {
      $(this).removeClass("Header--transparent");
    });
    $(".page-uus-kontor .Header").on("mouseleave", function () {
      $(this).addClass("Header--transparent");
    });
  }

  //Arrow scroll down
  $(".uus-kontor__arrow").on("click", function () {
    let container = $(this).closest(".shopify-section");
    $("html, body").animate(
      { scrollTop: parseInt($(container).next().offset().top) - 20 },
      500
    );
  });

  //Anchor scroll to form
  $(".uus-kontor__container .form_anchor").on("click", function () {
    $("html, body").animate(
      {
        scrollTop:
          parseInt(
            $(".uus-kontor__container .contact-form-container").offset().top
          ) - 40,
      },
      500
    );
  });

  //Anchor scroll to form
  $(".uus-kontor__container .slider_anchor").on("click", function () {
    $("html, body").animate(
      {
        scrollTop:
          parseInt($("#shopify-section-page-uus-kontor-slider").offset().top) -
          40,
      },
      500
    );
  });

  //Collection slider
  $(
    ".uus-kontor-items-screen .uus-kontor-wrapper .uus-kontor__text-slider"
  ).slick({
    infinite: true,
    slidesToShow: 1,
    slidesToScroll: 1,
    dots: false,
    swipe: false,
    arrows: false,
    speed: 300,
    fade: true,
    cssEase: "linear",
  });
  $(".uus-kontor-items-screen .uus-kontor-wrapper .uus-kontor__img-slider")
    .slick({
      infinite: true,
      slidesToShow: 1,
      slidesToScroll: 1,
      dots: true,
      swipe: false,
      arrows: true,
      nextArrow: $(".uus-kontor__slider-button.next"),
      prevArrow: $(".uus-kontor__slider-button.prev"),
    })
    .on("afterChange", function (event, slick, direction) {
      let way = direction == "right" ? "slickPrev" : "slickNext";
      $(
        ".uus-kontor-items-screen .uus-kontor-wrapper .uus-kontor__text-slider"
      ).slick(way);
    });

  //Collection first init
  (async function firstCollectionInit() {
    let initCollection = $(
      ".uus-kontor__menu-wrapper .uus-kontor__menu-item.active"
    ).attr("data-name");
    let html = await (
      await fetch(
        `${location.origin}/collections/${initCollection}?view=office`
      )
    ).text(); // html as text
    let doc = new DOMParser().parseFromString(html, "text/html");
    let products = [];
    $(doc.body)
      .find(".ProductItem")
      .each(function () {
        products.push({
          html: `<div class="ProductItem">
                    ${$(this).html()}
                </div>`,
        });
      });
    initCollectionsList(initCollection, products);
  })();
  //Collection Menu block
  $(".uus-kontor__menu-wrapper .uus-kontor__menu-item").on(
    "click",
    async function () {
      let index = $(this).attr("data-index"),
        collection = $(this).attr("data-name"),
        title = $(this).attr("data-title");
      $(".uus-kontor__mob-title span").html(title);
      $(".uus-kontor__menu-wrapper .uus-kontor__menu-item.active").removeClass(
        "active"
      );
      $(this).addClass("active");
      let html = await (
        await fetch(`${location.origin}/collections/${collection}?view=office`)
      ).text(); // html as text
      let doc = new DOMParser().parseFromString(html, "text/html");
      let products = [];
      $(doc.body)
        .find(".ProductItem")
        .each(function () {
          products.push({
            html: `<div class="ProductItem">
                    ${$(this).html()}
                </div>`,
          });
        });
      initCollectionsList(collection, products);
      if ($(window).width() < 1008) {
        $(".uus-kontor__menu").toggle();
      }
    }
  );

  function chunkArray(myArray, chunk_size) {
    var results = [];

    while (myArray.length) {
      results.push(myArray.splice(0, chunk_size));
    }

    return results;
  }

  function getPriceValue(value) {
    // console.log(value.toString().replace(".", ","))
    return value.toString().replace(".", ",");
  }

  //Init Collection wrapper
  let productsByPages = [];

  function initCollectionsList(collection, data) {
    let container = $(
        ".uus-kontor__collections_wrapper .uus-kontor__collection-container"
      ),
      inner = container.find(".uus-kontor__collection-inner-wrapper"),
      dataTaxText = inner.data("tax-text"),
      dataTaxValue = inner.data("tax-value"),
      loader = container.find(".loader");
    loader.fadeIn(300, function () {
      inner.empty();
      productsByPages = chunkArray(data, 8);
      $(productsByPages[0]).each(function (index, item) {
        let template = item.html;
        inner.append(template);
      });
      window.changeTax();
      if (productsByPages.length > 1) {
        let pagesLength = productsByPages.length,
          paginatorTemplate = ``;
        for (lengthIndex = 0; lengthIndex < pagesLength; lengthIndex++) {
          paginatorTemplate += `<a class="Pagination__NavItem ${
            lengthIndex == 0 ? "is-active" : "Link Link--primary"
          }" data-index="${lengthIndex}">${lengthIndex + 1}</a>`;
        }
        let pagination = `
                    <div class="Pagination Text--subdued" bis_skin_checked="1">
                        <div class="Pagination__Nav" bis_skin_checked="1">
                            <a class="Pagination__NavItem Link Link--primary disabled" rel="prev" data-index="0">
                                <svg class="Icon Icon--select-arrow-left" role="presentation" viewBox="0 0 11 18">
                                <path d="M9.5 1.5L1.5 9l8 7.5" stroke-width="2" stroke="currentColor" fill="none" fill-rule="evenodd" stroke-linecap="square"></path>
                                </svg>
                            </a>
                            ${paginatorTemplate}
                            <a class="Pagination__NavItem Link Link--primary" rel="next" data-index="1">
                                <svg class="Icon Icon--select-arrow-right" role="presentation" viewBox="0 0 11 18">
                                <path d="M1.5 1.5l8 7.5-8 7.5" stroke-width="2" stroke="currentColor" fill="none" fill-rule="evenodd" stroke-linecap="square"></path>
                                </svg>
                            </a>
                        </div>
                    </div>
                `;
        inner.append(pagination);
        //Pagination Event
        $(".uus-kontor__collections_wrapper .Pagination__NavItem").on(
          "click",
          function () {
            let pageIndex = $(this).attr("data-index"),
              collection = $(
                ".uus-kontor__menu-wrapper .uus-kontor__menu-item.active"
              ).attr("data-name");
            console.log(collection, pageIndex);
            collectionsListReload(collection, pageIndex);
          }
        );
      }
    });
    setTimeout(function () {
      loader.fadeOut(300);
    }, 1000);
  }

  //Collection Page Reload
  function collectionsListReload(collection, pageIndex) {
    let container = $(
        ".uus-kontor__collections_wrapper .uus-kontor__collection-container"
      ),
      inner = container.find(".uus-kontor__collection-inner-wrapper"),
      dataTaxText = inner.data("tax-text"),
      dataTaxValue = inner.data("tax-value"),
      loader = container.find(".loader"),
      currentIndex = $(".Pagination__NavItem.is-active").attr("data-index");

    if (pageIndex != currentIndex) {
      loader.fadeIn(300, function () {
        inner.empty();
        $(productsByPages[pageIndex]).each(function (index, item) {
          let template = item.html;
          inner.append(template);
        });
        window.changeTax();
        if (productsByPages.length > 1) {
          let pagesLength = productsByPages.length,
            paginatorTemplate = ``;
          pageIndex = parseInt(pageIndex);
          for (lengthIndex = 0; lengthIndex < pagesLength; lengthIndex++) {
            paginatorTemplate += `<a class="Pagination__NavItem ${
              lengthIndex == pageIndex ? "is-active" : "Link Link--primary"
            }" data-index="${lengthIndex}">${lengthIndex + 1}</a>`;
          }
          let pagination = `
                        <div class="Pagination Text--subdued" bis_skin_checked="1">
                            <div class="Pagination__Nav" bis_skin_checked="1">
                                <a class="Pagination__NavItem Link Link--primary ${
                                  pageIndex > 0 ? "" : "disabled"
                                }" rel="prev" data-index="${
            pageIndex > 0 ? pageIndex - 1 : 0
          }">
                                    <svg class="Icon Icon--select-arrow-left" role="presentation" viewBox="0 0 11 18">
                                    <path d="M9.5 1.5L1.5 9l8 7.5" stroke-width="2" stroke="currentColor" fill="none" fill-rule="evenodd" stroke-linecap="square"></path>
                                    </svg>
                                </a>
                                ${paginatorTemplate}
                                <a class="Pagination__NavItem Link Link--primary ${
                                  pageIndex < pagesLength - 1 ? "" : "disabled"
                                }" rel="next" data-index="${
            pageIndex < pagesLength - 1 ? pageIndex + 1 : pagesLength - 1
          }">
                                    <svg class="Icon Icon--select-arrow-right" role="presentation" viewBox="0 0 11 18">
                                    <path d="M1.5 1.5l8 7.5-8 7.5" stroke-width="2" stroke="currentColor" fill="none" fill-rule="evenodd" stroke-linecap="square"></path>
                                    </svg>
                                </a>
                            </div>
                        </div>
                    `;
          inner.append(pagination);
          //Pagination Event
          $(".uus-kontor__collections_wrapper .Pagination__NavItem").on(
            "click",
            function () {
              let pageIndex = $(this).attr("data-index"),
                collection = $(
                  ".uus-kontor__menu-wrapper .uus-kontor__menu-item.active"
                ).attr("data-name");
              console.log(collection, pageIndex);
              collectionsListReload(collection, pageIndex);
            }
          );
        }
      });
      setTimeout(function () {
        $("html, body").animate(
          {
            scrollTop: parseInt(
              $(".uus-kontor__collections-screen").offset().top
            ),
          },
          500
        );
        loader.fadeOut(300);
      }, 1000);
    }
  }

  //Collection Menu Toggle
  $(".uus-kontor__menu-title").on("click", function () {
    if (
      $(".uus-kontor__menu-title .uus-kontor__menu-title-icon").is(":visible")
    ) {
      let container = $(".uus-kontor__menu-wrapper"),
        svg = $(".uus-kontor__menu-title .uus-kontor__menu-title-icon svg");
      if (container.is(":visible")) {
        container.slideUp();
        svg.css("transform", "rotate(180deg)");
      } else {
        container.slideDown();
        svg.css("transform", "rotate(0deg)");
      }
    }
  });
});
$(window).on("load", function () {
  //Collection slider
  $(
    ".vanast-collections-items-screen .vanast-collections-wrapper .vanast-nutikaks__text-slider"
  ).slick({
    infinite: true,
    slidesToShow: 1,
    slidesToScroll: 1,
    dots: false,
    swipe: false,
    speed: 300,
    fade: true,
    cssEase: "linear",
  });
  setTimeout(function () {
    $(".vanast-nutikaks__img-slider")
      .slick({
        lazyLoad: "progressive",
        infinite: true,
        slidesToShow: 1,
        slidesToScroll: 1,
        dots: true,
        arrows: false,
      })
      .on("afterChange", function (event, slick, direction) {
        console.log(direction);
        let way = direction == "right" ? "slickPrev" : "slickNext";
        $(
          ".vanast-collections-items-screen .vanast-collections-wrapper .vanast-nutikaks__text-slider"
        ).slick(way);
      });
  }, 100);

  //Change size item
  $(".vanast-nutikaks__custom-size-menu-item").on("click", function () {
    let currentButton = $(this);
    if (!currentButton.hasClass("active")) {
      let currentIndex = $(this).attr("data-index");
      $(".vanast-nutikaks__features-item.active").fadeOut(300, function () {
        $(
          ".vanast-nutikaks__custom-size-menu-item.active, .vanast-nutikaks__features-item.active"
        ).removeClass("active");
        currentButton.addClass("active");
        $(
          `.vanast-nutikaks__features-item[data-index="${currentIndex}"`
        ).fadeIn(300, function () {
          $(this).addClass("active");
        });
      });
    }
  });

  //Customers slider
  $(".vanast-customers-wrapper.title-slider").slick({
    infinite: true,
    slidesToShow: 6,
    slidesToScroll: 1,
    dots: false,
    arrows: true,
    prevArrow: `
            <button type='button' class='slick-prev pull-left'>
                <svg width="14" height="23" viewBox="0 0 14 23" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M13.0809 20.1251L4.99422 11.4084L13.0809 2.69167L10.5838 -1.09152e-07L1.47601e-05 11.4084L10.5838 22.8168L13.0809 20.1251Z" fill="#939C9E"/>
                </svg>
            </button>`,
    nextArrow: `
            <button type='button' class='slick-next pull-right'>
                <svg width="14" height="23" viewBox="0 0 14 23" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M0.0808097 2.69179L8.16746 11.4085L0.0808104 20.1252L2.57791 22.8169L13.1617 11.4085L2.57791 0.000121961L0.0808097 2.69179Z" fill="#939C9E"/>
                </svg>
            </button>`,
    responsive: [
      {
        breakpoint: 1280,
        settings: {
          slidesToShow: 4,
        },
      },
      {
        breakpoint: 920,
        settings: {
          slidesToShow: 3,
        },
      },
      {
        breakpoint: 768,
        settings: "unslick",
      },
    ],
  });
  $(".vanast-customers-wrapper.block-slider").slick({
    infinite: true,
    slidesToShow: 2,
    slidesToScroll: 1,
    dots: true,
    arrows: false,
    responsive: [
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 1,
        },
      },
    ],
  });
  //Anchor scroll to form
  $(".vanast-nutikaks__container .form_anchor").on("click", function () {
    console.log("click");
    $("html, body").animate(
      {
        scrollTop:
          parseInt(
            $(".vanast-nutikaks__container .contact-form-container").offset()
              .top
          ) - 40,
      },
      500
    );
  });

  // if($('.template-collection').length && $(window).width() >= 1100) {
  //     const targetNode = document.querySelector('.CollectionMain');

  //     const config = { attributes: true, childList: true, subtree: true };

  //     const callback = function(mutationsList, observer) {
  //         for(const mutation of mutationsList) {
  //             if($('.usf-label').length) {
  //                 setTimeout(function() {
  //                     let height = $('.collection__top-wrapper').height();

  //                     $('.CollectionInner__Sidebar').css({
  //                       'cssText': `top: -${+height + 122}px!important`
  //                     })
  //                 }, 50)
  //                 observer.disconnect();
  //             }
  //         }
  //     };

  //     const observer = new MutationObserver(callback);

  //     observer.observe(targetNode, config);
  // }
});

$("body").on("click", (evt) => {
  let isPopup =
    $('#collection-sort-popoverv2[aria-hidden="false"]').length !== 0 &&
    !$('#collection-sort-popoverv2[aria-hidden="false"]').is(evt.target) &&
    $('#collection-sort-popoverv2[aria-hidden="false"]').has(evt.target)
      .length === 0 &&
    !$(evt.target).is($("#usf-new-sortbtn")) &&
    $("#usf-new-sortbtn").has(evt.target).length === 0;
  if (isPopup) {
    document
      .querySelector('#collection-sort-popoverv2 [data-action="close-popover"]')
      .click();
  }
});

$(document).ready(function () {
  $(".faq__question").on("click", function () {
    if (!$(this).hasClass("active")) {
      $(this).next().slideDown();
      $(".faq__question.active").next().slideUp();
      $(".faq__question.active").removeClass("active");
      $(this).addClass("active");
    } else {
      $(this).removeClass("active");
      $(this).next().slideUp();
    }
  });
});

// Handle checkout btn click
$("body").on("click", ".Cart__Checkout", (e) => {
  e.preventDefault();
  let $agreeCheckbox = $("input#agree");
  let $errorElm = $agreeCheckbox.parents("div").siblings(".Cart__Error");

  if ($agreeCheckbox.prop("checked")) {
    $errorElm.hide();
    location.href = Shopify.routes.root + "checkout";
  } else {
    $errorElm.show();
  }
});

$(document).ready(function () {
  setTimeout(() => {
    $(".CollectionToolbar__Group").hover(
      function () {
        $(this).find("#collection-sort-popoverv2").attr("aria-hidden", false);
      },
      function () {
        $(this).find("#collection-sort-popoverv2").attr("aria-hidden", true);
      }
    );
  }, 500);

  $(".l-slider__list").slick({
    dots: true,
    infinite: true,
    speed: 300,
    autoplay: true,
    autoplaySpeed: 3000,
    slidesToShow: 10,
    swipeToSlide: true,
    responsive: [
      {
        breakpoint: 1930,
        settings: {
          slidesToShow: 6,
        },
      },
      {
        breakpoint: 750,
        settings: {
          slidesToShow: 4,
        },
      },
      {
        breakpoint: 599,
        settings: {
          slidesToShow: 3,
          // variableWidth: true,
        },
      },
    ],
  });
  $(".r-slider__list").slick({
    dots: true,
    speed: 300,
    slidesToShow: 6,
    swipeToSlide: true,
    infinite: true,
    responsive: [
      {
        breakpoint: 2399,
        settings: {
          slidesToShow: 4,
        },
      },
      {
        breakpoint: 1239,
        settings: {
          dots: false,
          variableWidth: true,
          slidesToShow: 1,
        },
      },
    ],
  });

  $(".f-col__list").slick({
    dots: true,
    infinite: false,
    speed: 300,
    slidesToShow: 5,
    touchThreshold: 100,
    swipeToSlide: true,
    responsive: [
      {
        breakpoint: 2399,
        settings: {
          slidesToShow: 3,
        },
      },
      {
        breakpoint: 1239,
        settings: {
          variableWidth: true,
          slidesToShow: 1,
          slidesToScroll: 1,
          dots: false,
          touchThreshold: 100,
        },
      },
    ],
  });
  $(".mosaic__img--slider").slick({
    slidesToShow: 1,
    arrows: false,
    dots: true,
    fade: true,
  });

  $(".popup-close").click(function () {
    $(this).closest(".popup").removeClass("active");
  });
  $(".popup").click(function (e) {
    if (!$(e.target).closest(".popup-inner").length) {
      $(this).removeClass("active");
    }
  });

  if (!$('.product__tab-content[data-index="1"] ul li strong').length) {
    $('.product__tab-content[data-index="1"]').attr("data-not-format", "true");
  }
  $(".product__tab").click(function () {
    let index = $(this).attr("data-index");
    $(".product__tab, .product__tab-content").removeClass("active");
    $(this).addClass("active");
    $(`.product__tab-content[data-index="${index}"]`).addClass("active");
  });

  $(".s-remake__mobile-tab").click(function () {
    $(this).toggleClass("active");
    $(this).siblings(".m-tabs__content").slideToggle();
  });

  $(".article__content-imgs").each(function () {
    $(this).wrap('<div class="article__content-imgs-wrap"></div>');
  });
  $(".article__content img").each(function () {
    if (!$(this).closest(".article__content-imgs").length) {
      $(this).wrap('<div class="article__content-img"></div>');

      let alt = $(this).attr("alt");
      if (alt) {
        if (alt.indexOf("video--") !== -1) {
          let video = alt.split("video--");
          $(this)
            .closest(".article__content-img")
            .addClass("article__content-img--video");
          $(
            `<video class="article__video" controls src="${video[1]}"></video>`
          ).insertAfter($(this));
          $(this).wrap('<div class="article__content-img-inner"></div>');
        } else {
          alt = alt.split("---");
          if (alt[1]) {
            $(
              `<div class="article__content-alt-strong">${alt[1]}</div>`
            ).insertAfter($(this));
          }
          $(`<div class="article__content-alt">${alt[0]}</div>`).insertAfter(
            $(this)
          );
        }
      }
    }
  });
  $(".article__content-img").each(function () {
    $(this).closest("p").css("position", "static");
  });
  $(document).on("click", ".article__content-img-inner", function (e) {
    let img = e.target.closest(".article__content-img-inner");
    $(img).hide();
    $(img).siblings("video").show();
    $(img).siblings("video")[0].play();
  });

  if (
    $(window).innerWidth() >= 1008 &&
    $(".article__related-list .ArticleItem").length > 2
  ) {
    $(".article__related-list").slick({
      infinite: false,
      slidesToShow: 2,
      arrows: false,
      dots: true,
    });
  }

  $("[data-open-showroom]").click(function () {
    $(".c-popup").addClass("active");
  });

  $("[data-kontor-menu-toggle]").click(() => {
    $(".uus-kontor__menu").toggle();
  });
  if ($(window).width() < 992) {
    $(".logos__list").slick({
      dots: true,
      infinite: false,
      speed: 300,
      slidesToShow: 1,
      variableWidth: true,
      arrows: false,
    });
  }
  $(".o-slider").slick({
    dots: true,
    speed: 300,
    slidesToShow: 1,
    fade: true,
    prevArrow:
      '<button type="button" class="slick-prev pull-left"><svg xmlns="http://www.w3.org/2000/svg" width="24" height="25" viewBox="0 0 24 25" fill="none"> <path d="M13.5703 18.6455L15.0703 17.1455L10.5 12.5752L15.0703 8.00488L13.5703 6.50488L7.5 12.5752L13.5703 18.6455Z" fill="#530058"/> </svg></button>',
    nextArrow:
      '<button type="button" class="slick-next pull-right"><svg xmlns="http://www.w3.org/2000/svg" width="24" height="25" viewBox="0 0 24 25" fill="none"> <path d="M11 6.50488L9.5 8.00488L14.0703 12.5752L9.5 17.1455L11 18.6455L17.0703 12.5752L11 6.50488Z" fill="#530058"/> </svg></button>',
    responsive: [
      {
        breakpoint: 768,
        settings: {
          arrows: false,
        },
      },
    ],
  });
  $(".footer__sub-btn").click(function () {
    $(".newsletter__popup").addClass("active");
  });

  $(".Drawer__link[data-parent]").click(function () {
    $(this).siblings(".Drawer__submenu").slideToggle();
    $(this).toggleClass("opened");
  });

  $(document).on("change", ".related__select", function (e) {
    let option = $(e.target).find("option:selected");
    let priceWrap = $(e.target)
      .closest(".related__item")
      .find(".related__item-price");
    priceWrap.attr("data-price", option.attr("data-price"));
    priceWrap.attr("data-tax", option.attr("data-tax-price"));
    priceWrap.html(option.attr("data-price"));
  });

  setTimeout(() => {
    $(".single-option-selector").customSelect();
  }, 200);

  $(document).on("click", ".filters__close", function () {
    $(".usf-facets").removeClass("active");
    $("body").removeClass("muted");
  });

  $(document).on("click", ".filters__open", function () {
    $("body").addClass("muted");
    $(".usf-facets").addClass("active");
  });

  $(document).on("click", "body.muted", function (e) {
    if (!$(e.target).closest(".usf-facets").length) {
      $(".usf-facets").removeClass("active");
      $("body").removeClass("muted");
    }
  });

  let magnifiers = document.querySelectorAll(".magnifier");

  magnifiers.forEach(function (magnifier) {
    let native_width = 0;
    let native_height = 0;
    magnifier.addEventListener("mousemove", function (e) {
      if (!native_width && !native_height) {
        let image_object = new Image();
        image_object.src =
          this.querySelector(".productImage").getAttribute("src");
        let magnifierGlass = this.querySelector(".productImage_magnify");
        magnifierGlass.style.background = 'url("' + image_object.src + '")';
        native_width = image_object.width;
        native_height = image_object.height;
      } else {
        let magnify_offset = this.getBoundingClientRect();
        let mx = e.pageX - magnify_offset.left;
        let my = e.pageY - magnify_offset.top;

        if (
          mx < this.offsetWidth &&
          my < this.offsetHeight &&
          mx > 0 &&
          my > 0
        ) {
          this.querySelector(".productImage_magnify").style.display = "block";
        } else {
          this.querySelector(".productImage_magnify").style.display = "none";
        }
        if (
          this.querySelector(".productImage_magnify").style.display === "block"
        ) {
          let rx =
            Math.round(
              (mx / this.querySelector(".productImage").offsetWidth) *
                native_width -
                this.querySelector(".productImage_magnify").offsetWidth / 2
            ) * -1;
          let ry =
            Math.round(
              (my / this.querySelector(".productImage").offsetHeight) *
                native_height -
                this.querySelector(".productImage_magnify").offsetHeight / 2
            ) * -1;
          let bgp = rx + "px " + ry + "px";

          let px =
            mx - this.querySelector(".productImage_magnify").offsetWidth / 2;
          let py =
            my - this.querySelector(".productImage_magnify").offsetHeight / 2;
          this.querySelector(".productImage_magnify").style.left = px + "px";
          this.querySelector(".productImage_magnify").style.top = py + "px";
          this.querySelector(".productImage_magnify").style.backgroundPosition =
            bgp;
        }
      }
    });
    magnifier.addEventListener("mouseleave", function (e) {
      this.querySelector(".productImage_magnify").style.display = "none";
    });
  });
  $(".product__gallery-item").click(function (e) {
    e.preventDefault();
  });
});
